export default __webpack_public_path__ + "static/media/graphic-header.1c0c2e02.svg";